import type { Product } from "@shared/types/ProductLine";

const validContainerSizesForOunceCalculation = [
  "mL",
  "oz",
  "L",
  "bbl",
  "gal"
];

const ounceConversions = {
  "mL": 0.033814,
  "oz": 1,
  "L": 33.814,
  "bbl": 3968,
  "gal": 128
}

export const ouncesInContainer = (product: Product): number | null => {
  let container_size: any = product.container_size;
  if (container_size.toString().includes("/")) {
    const fraction = container_size.split("/");
    container_size = fraction[0] / fraction[1];
  }
  if (ounceConversions[product.container_units]) {
    return container_size * ounceConversions[product.container_units];
  }
  return null;
};

export const canCalculateOunces = (product: Product, isCase: boolean = false): boolean => {
  return validContainerSizesForOunceCalculation.includes(product.container_units) &&
    (!isCase || product.container_case_size > 0);
};

export const pricePerOunce = (product: Product, price: number, isCase: boolean = false): string => {
  if (isCase) {
    return (price / (product.container_case_size * ouncesInContainer(product))).toFixed(2);
  } else if (product.full_sleeve_only){
    return (price / (product.container_carton_size * ouncesInContainer(product))).toFixed(2);
  }
  else {
    return (price / ouncesInContainer(product)).toFixed(2);
  }
};
